var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { attrs: { id: "voiceSceneTeacher" } }, [
    _c("div", { staticClass: "left" }, [
      _c(
        "div",
        { staticClass: "header kaohe" },
        [
          _c("span", [
            _vm._v("考核点评（"),
            _c("span", [_vm._v(_vm._s(_vm.name))]),
            _vm._v("）")
          ]),
          _vm._v(" "),
          _vm.passedStatus != null
            ? [
                _vm.passedStatus
                  ? _c("div", { staticClass: "pass" }, [
                      _c("span", [_vm._v("考核通过")])
                    ])
                  : _c(
                      "div",
                      { staticClass: "nopass" },
                      [
                        _c("span", [_vm._v("考核不通过")]),
                        _vm._v(" "),
                        _vm.showBtn
                          ? [
                              _c(
                                "a",
                                {
                                  staticClass: "btn",
                                  on: {
                                    click: function($event) {
                                      return _vm.updateExamStatus(1)
                                    }
                                  }
                                },
                                [_vm._v("继续考核")]
                              ),
                              _vm._v(" "),
                              _c(
                                "a",
                                {
                                  staticClass: "btn red",
                                  on: {
                                    click: function($event) {
                                      return _vm.updateExamStatus(0)
                                    }
                                  }
                                },
                                [_vm._v("结束考核")]
                              )
                            ]
                          : _vm._e()
                      ],
                      2
                    )
              ]
            : _vm._e()
        ],
        2
      ),
      _vm._v(" "),
      _c("div", { staticClass: "content" }, [
        _c("p", [_vm._v("考核状态")]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "box" },
          [
            _c(
              "p",
              [
                _c(
                  "el-radio",
                  {
                    attrs: { label: 1 },
                    model: {
                      value: _vm.effectStatus,
                      callback: function($$v) {
                        _vm.effectStatus = $$v
                      },
                      expression: "effectStatus"
                    }
                  },
                  [_vm._v("有效")]
                )
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "p",
              [
                _c(
                  "el-radio",
                  {
                    attrs: { label: 0 },
                    model: {
                      value: _vm.effectStatus,
                      callback: function($$v) {
                        _vm.effectStatus = $$v
                      },
                      expression: "effectStatus"
                    }
                  },
                  [_vm._v("无效")]
                )
              ],
              1
            ),
            _vm._v(" "),
            _vm.effectStatus == 0
              ? [
                  _c(
                    "p",
                    [
                      _c("el-input", {
                        attrs: {
                          placeholder: "输入无效原因，显示在考核得分",
                          clearable: ""
                        },
                        model: {
                          value: _vm.effectReason,
                          callback: function($$v) {
                            _vm.effectReason = $$v
                          },
                          expression: "effectReason"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("p", [_vm._v("例如：通话中挂断，本次考核无评分与建议")])
                ]
              : _vm._e()
          ],
          2
        ),
        _vm._v(" "),
        _vm.effectStatus == 1
          ? _c("p", { staticClass: "totalScore" }, [
              _c("span", [_vm._v("考核点评")])
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.effectStatus == 1
          ? _c(
              "div",
              { staticClass: "box" },
              [
                _vm._l(_vm.gradeList, function(f, index) {
                  return [
                    _c("p", { staticClass: "name" }, [_vm._v(_vm._s(f.name))]),
                    _vm._v(" "),
                    _vm._l(f.childList, function(s, key) {
                      return [
                        _c("p", { staticClass: "second name" }, [
                          _c("span", [_vm._v("*")]),
                          _vm._v(_vm._s(s.name))
                        ]),
                        _vm._v(" "),
                        _vm._l(s.childList, function(t, tkey) {
                          return _c(
                            "p",
                            { staticClass: "second" },
                            [
                              _c(
                                "el-radio",
                                {
                                  attrs: { label: t.id },
                                  on: { change: _vm.computeTotalScore },
                                  model: {
                                    value: s.checked,
                                    callback: function($$v) {
                                      _vm.$set(s, "checked", $$v)
                                    },
                                    expression: "s.checked"
                                  }
                                },
                                [_vm._v(_vm._s(t.name))]
                              )
                            ],
                            1
                          )
                        })
                      ]
                    })
                  ]
                })
              ],
              2
            )
          : _vm._e(),
        _vm._v(" "),
        _vm.effectStatus == 1
          ? _c("p", { staticClass: "advice" }, [
              _c("span", [_vm._v("考核建议")]),
              _vm._v(" "),
              _c(
                "span",
                { staticClass: "btn-advice", on: { click: _vm.addEvaluate } },
                [_vm._v("添加建议")]
              )
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.effectStatus == 1
          ? _c(
              "div",
              { staticClass: "box" },
              _vm._l(_vm.evaluateList, function(e, key) {
                return _c(
                  "div",
                  { staticClass: "row" },
                  [
                    _c("el-input", {
                      attrs: { placeholder: "输入建议", clearable: "" },
                      model: {
                        value: e.evaluate,
                        callback: function($$v) {
                          _vm.$set(e, "evaluate", $$v)
                        },
                        expression: "e.evaluate"
                      }
                    }),
                    _vm._v(" "),
                    _c(
                      "span",
                      {
                        on: {
                          click: function($event) {
                            return _vm.delEvaluate(key)
                          }
                        }
                      },
                      [_vm._v("删除")]
                    )
                  ],
                  1
                )
              }),
              0
            )
          : _vm._e()
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "save" }, [
        _c("span", { staticClass: "score" }, [
          _vm._v(
            "总分：" +
              _vm._s(_vm.gradeScore ? _vm.gradeScore : _vm.totalScore) +
              "分"
          )
        ]),
        _vm._v(" "),
        _c("a", { on: { click: _vm.saveScore } }, [_vm._v("保存")])
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "right" }, [
      _c("div", { staticClass: "header" }, [_vm._v("客服考核记录")]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "content" },
        [
          _vm.list.length == 0
            ? _c("div", { staticClass: "kong" }, [
                _c("img", {
                  attrs: {
                    src: require("@/assets/images/voiceScene/icon_kong_list.png")
                  }
                }),
                _vm._v(" "),
                _c("p", [_vm._v("该客服没有考核记录")])
              ])
            : [
                _vm._l(_vm.list, function(l, index) {
                  return _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "infinite-scroll",
                          rawName: "v-infinite-scroll",
                          value: _vm.load,
                          expression: "load"
                        }
                      ],
                      staticClass: "list",
                      attrs: { "infinite-scroll-disabled": "disabled" }
                    },
                    [
                      _c(
                        "div",
                        {
                          class: { top: true, hasborder: l.effectStatus == 1 }
                        },
                        [
                          l.recordType == "Each"
                            ? _c("span", { staticClass: "type" }, [
                                _vm._v("对练")
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          l.recordType == "Teacher"
                            ? _c("span", { staticClass: "type" }, [
                                _vm._v("陪练")
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          l.recordType == "Exam"
                            ? _c("span", { staticClass: "type" }, [
                                _vm._v("考核")
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          _c("span", { staticClass: "time" }, [
                            _vm._v(_vm._s(l.beginTime))
                          ]),
                          _vm._v(" "),
                          _c(
                            "span",
                            {
                              class: {
                                score: true,
                                wuxiao: l.effectStatus == 0
                              }
                            },
                            [
                              _vm._v(
                                "\n\t\t\t\t\t\t\t\t" +
                                  _vm._s(
                                    l.effectStatus == 0
                                      ? "无效"
                                      : l.effectStatus == 1
                                      ? l.gradeScore
                                      : "待评分"
                                  ) +
                                  "\n\t\t\t\t\t\t\t"
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "a",
                            {
                              attrs: {
                                target: "_blank",
                                href: "/tjkStudy/kaoheTeacherDetail?id=" + l.id
                              }
                            },
                            [_c("span", { staticClass: "el-icon-arrow-right" })]
                          )
                        ]
                      ),
                      _vm._v(" "),
                      l.effectStatus == 1
                        ? _c(
                            "ul",
                            { staticClass: "clear" },
                            _vm._l(l.gradeList, function(g, key) {
                              return _c("li", [
                                _vm._v(
                                  _vm._s(g.name) + "：" + _vm._s(g.gradeScore)
                                )
                              ])
                            }),
                            0
                          )
                        : _vm._e()
                    ]
                  )
                }),
                _vm._v(" "),
                _vm.loading
                  ? _c("p", { staticClass: "nomore" }, [_vm._v("加载中...")])
                  : _vm._e(),
                _vm._v(" "),
                _vm.noMore
                  ? _c("p", { staticClass: "nomore" }, [_vm._v("没有更多了")])
                  : _vm._e()
              ]
        ],
        2
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-2e007e3a", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2e007e3a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/page/voiceScene/kaoheTeacher.vue
// module id = 1516
// module chunks = 0